import styled from "styled-components";

export const Body = styled.div`
    height: 80vh;
`;

export const MainTable = styled.div`
  justify-content: center;
  display: flex;
`;

export const MainText = styled.h1`
  text-align: center;
  margin-bottom: 2.5rem;
  margin-top: 1rem;
`